'use client'

import { RightIcon } from '@/_assets/icon-components'
import { getBrandSlug } from '@/_lib/brand-href'
import { IBranch } from '@/_types'
import { formatPhoneNumber } from '@/_utils/formatPhoneNumber'
import { Link } from '@/i18n/navigation'
import {
  Box,
  Button,
  Center,
  HStack,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import React from 'react'

const BranchCard = ({ data, activeShipperId }: { data: IBranch, activeShipperId: string }) => {
  const router = useRouter()
  const t = useTranslations()
  const { open, onToggle } = useDisclosure()

  const formattedNumber = formatPhoneNumber(data?.phone)

  const redirectToDetailed = (e: any, slug: string) => {
    e.stopPropagation();
    const shipperSlug = getBrandSlug(activeShipperId)
    const url = shipperSlug
      ? `/branches/${slug}?shipper_id=${shipperSlug}`
      : `/branches/${slug}`;
    router.push(url);
  };

  return (
    <Stack p={4} bg={'#fff'} rounded={'16px'} color="#1D2939">
      <Link href={'/branches/' + data?.slug}>
        <Text fontWeight={700} fontSize={18}>{data?.name}</Text>
      </Link>
      <Text fontSize={'sm'}>
        {data?.address}
      </Text>
      <Text fontSize={'sm'}>
        <Text color='#475467' as="span">{t('schedule_delivery')}:</Text> {data?.work_hour_start} - {data?.work_hour_end}
      </Text>
      <Text fontSize={'sm'}>
        <Text color='#475467' as="span">{t('schedule_branch')}:</Text> {data?.open_time} - {data?.close_time}
      </Text>
      <Text fontSize={'sm'}>
        <Text color='#475467' as="span">{t('phone')}:</Text>  <Link href={`tel:${data?.phone}`}>{formattedNumber}</Link>
      </Text>

      <Link
        href={`https://yandex.com/maps/?ll=${data?.location?.long}%2C${data?.location?.lat}&mode=whatshere&whatshere%5Bpoint%5D=${data?.location?.long}%2C${data?.location?.lat}&z=14`}
        target='_blank'
        rel='noreferrer'
      >
        <Center
          bg='primary'
          color='primary.text'
          _hover={{
            bg: 'primary.hover',
          }}
          px={4}
          h='40px'
          fontSize='14px'
          borderRadius='8px'
          fontWeight={700}
          textAlign='center'
        >
          {t('build_route')}
        </Center>
      </Link>

      <Button
        w='full'
        size={'md'}
        rounded={8}
        fontSize='14px'
        fontWeight={600}
        color={'primary'}
        variant={'outline'}
        colorScheme={'primary'}
        borderColor={'primary'}
        onClick={(e) => redirectToDetailed(e, data?.slug)}
      >
        {t('read_more')}
      </Button>
    </Stack>
  )
}

export default BranchCard
